// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"cf0b92cb","6850":"b9cd79d1"}[chunkId] + ".chunk.css";
};